import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteWheelPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
};

export const useDeleteWheelPartsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsWheelTyresParts>>,
      QueryError,
      DeleteWheelPartsInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, partId }: DeleteWheelPartsInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsWheelTyresParts(logId, itemId, partId);
    },
    {
      ...options
    }
  );
